import * as React from "react";
import { styled } from "@mui/material/styles";
import { Card, CardContent, CardHeader, Grid, Table } from "@mui/material";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import { Customer } from "../../types/customer";
import Linkify from "../../components/Linkify";
import { useUILabel } from "../../hooks/useUILabel";

interface ExpandMorePaymentTermProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMorePaymentTerm = styled((props: ExpandMorePaymentTermProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const ClientDetailsPanel = ({ data }: { data?: Customer }) => {
  const aboutLabel = useUILabel("client.about");
  const clientNameLabel = useUILabel("client.clientName");
  const phoneNumberLabel = useUILabel("common.phoneNumber");
  const emailLabel = useUILabel("common.email");
  const contactLabel = useUILabel("client.contact");
  const address1Label = useUILabel("client.address1");
  const address2Label = useUILabel("client.address2");
  const cityZipLabel = useUILabel("client.cityZip");
  const stateLabel = useUILabel("common.state");
  const socialMediasLabel = useUILabel("client.socialMedias");
  const linkedInLabel = useUILabel("client.linkedIn");
  const facebookLabel = useUILabel("client.facebook");
  const instagramLabel = useUILabel("client.instagram");
  const websiteLabel = useUILabel("client.website");
  const nALabel = useUILabel("client.nA");
  
  return (
    <Grid container spacing={1} sx={{ mb: 1 }}>
      <Grid item xs={12}>
        <Card>
          <CardHeader title={aboutLabel} />
          <CardContent>
            <Table sx={{ fontSize: 14 }}>
              <tbody>
                <tr>
                  <td width={"20%"}>{clientNameLabel}</td>
                  <td>{data?.first_name}</td>
                </tr>
                <tr>
                  <td>{phoneNumberLabel}</td>
                  <td>{data?.phone_number || nALabel}</td>
                </tr>
                <tr>
                  <td>{emailLabel}</td>
                  <td>{data?.email || nALabel}</td>
                </tr>
              </tbody>
            </Table>
          </CardContent>
        </Card>
        <Card sx={{ mt: 1 }}>
          <CardHeader title={contactLabel} />
          <CardContent>
            <Table sx={{ fontSize: 14 }}>
              <tbody>
                <tr>
                  <td width={"20%"}>{address1Label}</td>
                  <td>{data?.physical_address_1}</td>
                </tr>
                <tr>
                  <td>{address2Label}</td>
                  <td>{data?.physical_address_2}</td>
                </tr>
                <tr>
                  <td>{cityZipLabel}</td>
                  <td>
                    {data?.city} / {data?.zip}
                  </td>
                </tr>
                <tr>
                  <td>{stateLabel}</td>
                  <td>{data?.state}</td>
                </tr>
                {/*<tr>
                  <td>Country</td>
                  <td>{data?.country_id}</td>
                </tr>*/}
              </tbody>
            </Table>
          </CardContent>
        </Card>
        <Card sx={{ mt: 1 }}>
          <CardHeader title={socialMediasLabel} />
          <CardContent>
            <Table sx={{ fontSize: 14 }}>
              <tbody>
                <tr>
                  <td width={"20%"}>{linkedInLabel}</td>
                  <td>
                    <Linkify url={data?.linked_in} />
                  </td>
                </tr>
                <tr>
                  <td>{facebookLabel}</td>
                  <td>
                    <Linkify url={data?.facebook} />
                  </td>
                </tr>
                <tr>
                  <td>{instagramLabel}</td>
                  <td>
                    <Linkify url={data?.instagram} />
                  </td>
                </tr>
                <tr>
                  <td>{websiteLabel}</td>
                  <td>
                    <Linkify url={data?.website} />
                  </td>
                </tr>
              </tbody>
            </Table>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};
export default ClientDetailsPanel;
